// @flow
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';

const AcceptWrapper: StatelessFunctionalComponent<*> = styled.div`
  
  text-align: left;
  position: relative !important;

  span {
    line-height: 20px;
  }
  
  .buttonsBar {
    width: 100%;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
  }
`;

export default AcceptWrapper;
